// TOP画面遷移時データ
type LoginTopData = {
  // リダイレクト
  redirect?: string
  // ダウンロードキー
  downloadKey?: string
}

// リダイレクト種別定義
const REDIRECT_TYPE = {
  DOWNLOAD: 'download', // ダウンロード画面
  DOWNLOAD_DETAIL: 'download_detail', // ダウンロード詳細画面
  PASSWORD_UPDATE: 'password', // パスワード画面
} as const
type REDIRECT_TYPE = typeof REDIRECT_TYPE[keyof typeof REDIRECT_TYPE]

// 登録種別定義
const ENTRY_TYPE = {
  NEW: '0', // 新規登録
  RESET: '1', // リセット
} as const
type ENTRY_TYPE = typeof ENTRY_TYPE[keyof typeof ENTRY_TYPE]

// ログイン認証画面遷移時データ
type LoginAuthData = {
  // ユーザー名
  username: string
  // リダイレクト
  redirect?: string
  // ダウンロードキー
  downloadKey?: string
}

// ダウンロード画面遷移時データ
type DownloadData = {
  // ダウンロードキー
  downloadKey?: string
}

// ダウンロード詳細画面遷移時データ
type DownloadDetailData = {
  // ダウンロードキー
  downloadKey?: string
  // 検索有無
  search: string
}

// ワンタイムパスワード発行画面遷移時データ
type EntryAuthSendData = {
  // ユーザー名
  username: string
  // 登録種別
  type: string
  // リダイレクト
  redirect?: string
  // ダウンロードキー
  downloadKey?: string
}

// ワンタイムパスワード認証画面遷移時データ
type EntryAuthData = {
  // ユーザー名
  username: string
  // 登録種別
  type: string
  // リダイレクト
  redirect?: string
  // ダウンロードキー
  downloadKey?: string
}

// パスワード登録画面遷移時データ
type EntryData = {
  // ユーザー名
  username: string
  // ワンタイムパスワード
  onetimepassword: string
  // 登録種別
  type: string
  // リダイレクト
  redirect?: string
  // ダウンロードキー
  downloadKey?: string
}

// ライセンス契約書同意画面遷移時データ
type AgreeLicenseData = {
  // ユーザー名
  username: string
  // リダイレクト
  redirect?: string
  // ダウンロードキー
  downloadKey?: string
}

export {
  LoginTopData,
  LoginAuthData,
  EntryAuthSendData,
  DownloadData,
  DownloadDetailData,
  EntryAuthData,
  EntryData,
  AgreeLicenseData,
  REDIRECT_TYPE,
  ENTRY_TYPE,
}
